/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type QuestionnaireResponseStatus =
  (typeof QuestionnaireResponseStatus)[keyof typeof QuestionnaireResponseStatus];

export const QuestionnaireResponseStatus = {
  not_started: "not_started",
  in_progress: "in_progress",
  complete: "complete",
} as const;
